import React from 'react';
import FAQBase from './FAQBase';

const questions = [
  {
    question: 'Can I control when my child receives their inheritance?',
    answer:
      "The digital estate planning tool does not let you specify the ages at which a beneficiary receives an inheritance. To include age-based distributions, you'll need to work with a network attorney.",
  },
  {
    question:
      'If someone named in my documents moves or changes their name after becoming married, do I need to update the information?',
    answer:
      'Minor changes, such as a new address or last name, do not always require document updates, but it’s a good idea to review your plan periodically to make sure it still clearly identifies the intended person. You can come back to update your estate plan online as needed.',
  },
];

const AssetsFAQ = () => <FAQBase questions={questions} />;

export default AssetsFAQ;
